import { Component } from '@angular/core';
import {
  NavController,
  ModalController,
  AlertController,
  ToastController,
  ViewController,
  NavParams
} from 'ionic-angular';
import {Params} from "../../../params";
import * as firebase from 'firebase/app';
import * as moment from 'moment';

@Component({
  selector: 'page-addrequest',
  templateUrl: 'add.html'
})
export class AddRequestPage{
  customers : any;
  items = [];
  step : number = 1;
  customer;
  foods;
  plans;
  oldFoods = "";
  request = {
    type : "",
    customer : "",
    owner : Params.md5(Params.USER_DATA.email),
    datetime : firebase.database.ServerValue.TIMESTAMP,
    status : 0,
    datestart : moment().format(),
    obs_request : "",
    obs_decline : "",
    obs_approve : "",
    execution : {
      type : "",
      proccesed : false,
      date : ""
    },
    CP : {
      key : "",
      foods: [],
      old : {}
    },
    CF : {
      foods : [],
      old : []
    }
  }

  constructor(
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public viewCtrl: ViewController,
    public navParams: NavParams
  ){
    this.foods = this.navParams.get('foods');
    this.plans = this.navParams.get('plans');
    firebase.database().ref('/customers').once('value').then((snap)=>{
      const val = snap.val();
      this.customers = Object.keys(val).map(key =>{ return { key:key, ...val[key]}});
      this.initializeItems();

    });
  }
  initializeItems(){
    this.items = this.customers;
  }

  getItems(ev: any) {
    this.initializeItems();
    let val = ev.target.value;
    if (val && val.trim() != '') {
      this.items = this.items.filter((item) => {
        return (
          (item.name.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.lastname.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.rut.toLowerCase().indexOf(val.toLowerCase()) > -1) ||
          (item.email.toLowerCase().indexOf(val.toLowerCase()) > -1)
        );
      })
    }
    if(this.items.length>100){this.items = this.items.splice(0,100);}
  }

  requestTypeChange(){
    if(this.request.type=="CP"){
      this.request.CP.old["plan"] = this.customer.plan;
      this.request.CP.old["foods"] = this.customer.foods;
    }
    if(this.request.type=="CF"){
      this.oldFoods = "";
      this.request.CF.old = this.customer.foods;
      for(let f in this.customer.foods){
        let food = this.customer.foods[f];
        this.oldFoods = this.oldFoods + this.foods.data[food].name+", ";
      }
      this.request.CF.foods = this.plans.data[this.customer.plan].foods;
      console.log(this.request.CF.foods,this.customer.plan);
    }
  }

  open(customer){
    this.customer = customer;
    console.log(this.customer);
    this.step = 2;
    this.request.customer = customer.key;
  }

  foodName(key){
    let name = "";
    if(this.foods.data){
      if(this.foods.data[key]){
        return this.foods.data[key].name;
      }
    }
    return name;
  }

  add(){
    console.log(this.request);
    let processed = false;
    let title;
    let subTitle;
    if(this.request.type=="CP"){
      if(this.request.CP.key!="" && this.request.CP.foods.length>0){
        processed = true;
        title = "Confirmación Cambio de Plan";
        subTitle = "Se cursará una solicitud de cambio de plan para "+this.customer.name+" de "+this.plans.data[this.customer.plan].name+" con "+this.customer.foods.length+" comidas por <b>"+this.plans.data[this.request.CP.key].name+" con "+this.request.CP.foods.length+" comidas</b>"
      }
    }

    if(this.request.type=="CF"){
      if(this.request.CF.foods.length>0){
        processed = true;
        title = "Confirmación Cambio de Comidas";
        subTitle = "Se cursará una solicitud de cambio de comidas para "+this.customer.name+" de "+this.request.CF.old.length+" comidas por <b>"+this.request.CF.foods.length+" comidas</b>";
      }
    }

    if(this.request.type=="RE") {
      processed = true;
      title = "Confirmación de Reingreso";
      subTitle = "Se cursará una solicitud de reingreso para " + this.customer.name;
    }
    if(this.request.type=="CI1" || this.request.type=="CI2") {
      processed = true;
      title = "Confirmación de Inactivación";
      subTitle = "Se cursará una solicitud de inactivación para " + this.customer.name;
    }

    if(!processed){
      let alert = this.alertCtrl.create({
        title : "Error",
        subTitle : "Debe seleccionar todos los datos solicitados",
        buttons: ['Aceptar']
      })
      alert.present();
    }else{
      let alert = this.alertCtrl.create({
        title : title,
        subTitle : subTitle,
        buttons: [
          {
            text: 'Cancelar',
            role : 'cancel'
          },
          {
            text: 'Si, deseo solicitar',
            handler: () => {
              let date = moment(this.request.datetime).format("YYYYMMDD");
              const key = firebase.database().ref('requests/'+date).child(this.request.customer).push().key;
              this.request['key'] = key;
              console.log(key);
              firebase.database().ref('requests/'+date+'/'+this.request.customer+'/'+key).update(this.request)
                .then(()=>{
                  let toast = this.toastCtrl.create({
                    message: "Solicitud generada exitosamente",
                    duration: 3000
                  });
                  toast.present();
                  this.viewCtrl.dismiss();
                })
            }
          }
        ]
      })
      alert.present();
    }
  }

  planChange(){
    this.request.CP.foods = this.plans.data[this.request.CP.key].foods;
  }
}



// WEBPACK FOOTER //
// ./src/pages/changes/requests/add/add.ts